import { SupportedLocale } from "@/i18n";
import EnglishFlag from "./EnglishFlag";
import FrenchFlag from "./FrenchFlag";
import { SpanishFlag } from "./SpanishFlag";
import DutchFlag from "./DutchFlag";

export type FlagDef = React.FC<React.SVGProps<SVGSVGElement>>;

export const languageToFlag: { [key in SupportedLocale]: FlagDef } = {
  en: EnglishFlag,
  fr: FrenchFlag,
  es: SpanishFlag,
  nl: DutchFlag,
};
